export enum NoteOwner {
  CUSTOMER = "CUSTOMER",
  GL = "GL",
}
export interface LocalNote {
  id: string;
  content: string;
  image: null;
  is_pinned: boolean;
  image_id?: string;
  created_at: string;
  updated_at?: string;
  order?: number;
}

export interface Note extends LocalNote {
  predictor_id: string;
  created_at: string;
  deleted_at: string;
  type: string;
  owner_name: string;
}

export interface NotesResponse {
  CUSTOMER: Note[];
  GL: Note[];
}

export interface LocalNotes {
  CUSTOMER: LocalNote[];
  GL: LocalNote[];
}
